import { render, staticRenderFns } from "./TeacherCoursePage.vue?vue&type=template&id=6d26418e&scoped=true&"
import script from "./TeacherCoursePage.vue?vue&type=script&lang=js&"
export * from "./TeacherCoursePage.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCoursePage.vue?vue&type=style&index=0&id=6d26418e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d26418e",
  null
  
)

export default component.exports